import type * as React from 'react';
import { cn } from '../utils';

export interface FormRowProps {
  label: string;
  help?: string;
  required?: boolean;
  children: React.ReactNode;
  className?: string;
  htmlFor?: string;
}

export function FormRow({ label, help, required, children, className, htmlFor }: FormRowProps) {
  return (
    <div className={cn('flex flex-col', className)} style={{ marginTop: 7, marginBottom: 10 }}>
      <label
        htmlFor={htmlFor}
        className="mb-1 text-[12px] font-medium text-[var(--color-text-secondary)]"
      >
        {label}
        {required ? (
          <span className="ml-0.5 text-[var(--color-error)]" aria-hidden>
            *
          </span>
        ) : null}
      </label>
      {children}
      {help ? <p className="mt-1 text-[11px] text-[var(--color-text-tertiary)]">{help}</p> : null}
    </div>
  );
}
